export const getScreens = (state) => state.screens.screens;
